export default function Logo({ compact = false }) {
  return (
    <a
      href="#anasayfa"
      data-testid="brand-logo-link"
      className="flex items-center gap-3 group"
      aria-label="Konya Çekicim – Anasayfa"
    >
      <img
        src="/logo-badge-dark.png"
        alt="Konya Çekicim – Adem Ildırar 7/24 logo"
        width="48"
        height="48"
        className={`rounded-xl object-cover ${compact ? "h-11 w-11" : "h-12 w-12"}`}
      />
      <span className="sr-only">Konya Çekicim – Adem Ildırar, 7/24 çekici ve yol yardım</span>
    </a>
  );
}
